import { QualifiedFeature } from "fe-common/graphql";
import { DiagnosticAgentConfigurations } from "./agentConfiguration";
import {
  DiagnosticAgentType,
  PanelContext,
  PatientCaseGrouping,
  useDiagnosticAgentType,
} from "../../../context/diagnosticAgent";
import { KahunCategories } from "shared";

export interface DiagnosticAgentConfiguration {
  title: string;
  dataEntryPanelID: string;
  considerPanelIDs: string[];
}
export interface DataInputSectionConfiguration {
  id: string;
  // defaults determine whether a particular QF should be shown under this sub-group
  defaultForCategories?: KahunCategories[];
  defaultSections: PatientCaseGrouping[];
  defaultForFeatures?: string[];
  searchCategories?: (searchContext: PanelContext) => KahunCategories[]; // if different from default categories
  overrideSection?: PatientCaseGrouping; // switch findings to a section different from the parent group
  showSearch?: boolean;
  transformResult?: (
    qf: QualifiedFeature,
    context?: PanelContext,
  ) => QualifiedFeature;
  displayName: string;
  displayOrder: number;
  hasMyPatient?: boolean;
  allowRefinement?: boolean;
  allowYesNo?: boolean;
  searchSubCategories?: boolean;
}

export function getDiagnosticAgentConfiguration(
  t: DiagnosticAgentType,
): DiagnosticAgentConfiguration {
  return DiagnosticAgentConfigurations[t];
}

/**
 * hook version with context
 */
export function useDiagnosticAgentConfiguration(): DiagnosticAgentConfiguration {
  let [at] = useDiagnosticAgentType();
  return getDiagnosticAgentConfiguration(at);
}
